import { createRoot } from "react-dom/client"
import CssBaseline from "@material-ui/core/CssBaseline"
import { MuiThemeProvider } from "@material-ui/core/styles"
import StyleGuide from "pages/StyleGuide"
import { SnackbarProvider } from "notistack"
import theme from "base/theme"

if ( process.env.NODE_ENV !== "production" ) {
	console.log ( "MUI Theme:", theme )
}

const container = document.getElementById ("main")
const root = createRoot ( container )

root.render (
	<MuiThemeProvider theme={theme} >
		<CssBaseline/>
		<SnackbarProvider
			style={{ left: "initial", right: "20px" }}
			maxSnack={1}
			autoHideDuration={1000}
			anchorOrigin={{ vertical: "bottom", horizontal: "right" }} >
			<StyleGuide/>
		</SnackbarProvider>
	</MuiThemeProvider>,
	
)
